export default __webpack_public_path__ + "static/media/I_wdt_c_cap_3.2d6d8cd9.mp3";